import { render, staticRenderFns } from "./comrefresh.vue?vue&type=template&id=32f19e12"
import script from "./comrefresh.vue?vue&type=script&lang=js"
export * from "./comrefresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports